import Vue from 'vue'
// models component
import ShipVoyageNo from '@/models/ShipVoyageNo'
import ShipDaily from '@/models/ShipDaily'

export default class ShipTopFetch {
    // Ship Tops Fetch
    static of(shipId, params) {
        return Promise.resolve()
            .then(function () {
                ShipVoyageNo.deleteAll()
                return ShipVoyageNo.api()
                    .fetch(shipId)
                    .then(function (result) {
                        console.log('ShipVoyageNo.all()', ShipVoyageNo.all())
                    })
            })
            .then(function () {
                ShipDaily.deleteAll()
                return ShipDaily.api()
                    .fetch(shipId, {})
                    .then(function (result) {
                        console.log(
                            'ShipDaily.fetchByShipId()',
                            ShipDaily.fetchByShipId(shipId)
                        )
                    })
            })
            .catch(() => {
                return new Promise((resolve, reject) => {
                    reject(new Error())
                })
            })
    }
}
